export enum QuoteJobStatusTypes{
    Open = 1,
    Rejected = 2,
    Accepted = 3,
    Cancelled = 4,
    Deleted = 5,
    InTranslation = 8
}